import Popup from '../plugins/PluginPopup'
import initializePickers, { EnumPickerType } from '../plugins/PluginPicker.ts'
import SVGInject from '@iconfu/svg-inject'
import tippy, { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import Choices from 'choices.js'
import Swiper from 'swiper'
import {
    Navigation,
    EffectFade,
} from 'swiper/modules'
import { SwiperOptions } from 'swiper/types'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade';

declare const ciapeq: { [key: string]: string };

window.addEventListener('load', () => {

    const hash = window.location.hash;

    let locNumber = '';
    if (hash.length > 0) {
        // If hash exists, remove # from hash and change to uppercase

        locNumber = hash.replace("#", "");
        console.log(ciapeq);
        console.log(locNumber);

        // get only part from hash to ? if there are any tracking attributes
        locNumber = locNumber.split("?")[0];
        console.log(locNumber);

        // Save default hash before editing
        const hashBackup = locNumber;

        locNumber = locNumber.toUpperCase();
        console.log(locNumber);


        // Check if array with all available dwellings contains id found in url
        // console.log({ locNumber, allApartments: ciapeq })
        if (ciapeq[locNumber]) {
            console.log(ciapeq[locNumber]);
            // If true, create url for dwelling
            const url = `/popup/?id=${ciapeq[locNumber]}`
            getPopupsLink(url)
        }

    }

})

function getPopupsLink(url: string): void {

    const template = document.querySelector<HTMLElement>(
        '[data-item="content-popup"]',
    )

    console.log(url)
    new Popup({
        trigger: 'auto',
        openBtn: null,
        title: '',
        content: '',
        isTemplate: true,
        template: template,
        iconClose: false,
        btnClose: true,
        btnCloseContent: '',
        customClass: 'popup--investment',
        onAfterOpen() {
            handlePopupOpen(url)

            document.dispatchEvent(new CustomEvent('popup-init-table'))

        },
        onAfterClose() {
            history.replaceState(null, "", window.location.pathname + window.location.search);

        },
    })
}

function handlePopupOpen(url: string): void {

    const popup = document.querySelector<HTMLElement>('[data-popup="true"]')

    if (!popup) return

    const content = popup.querySelector<HTMLElement>('[data-popup="content"]')

    initializePopupPickers()
    initializeSliders()

    if (url && content) {

        const params = new URLSearchParams(url.split('?')[1]);

        const id = params.get('id');

        const lokName = getKeyByValue(ciapeq, id);

        history.replaceState(null, "", `#${lokName}`);

        fetchAndProcessContent(url, content, popup)
    }
}

function getKeyByValue(obj: any, value: any, strict = false) {
    if (!obj || typeof obj !== 'object') return null;

    for (const [k, v] of Object.entries(obj)) {
        if (strict) {
            if (v === value) return k;
        } else {
            // najpierw spróbuj luźne porównanie (np. "234" == 234)
            if (v == value) return k;
            // dodatkowo próbujemy porównać po stringach (bezpieczniej dla null/undefined)
            if (String(v) === String(value)) return k;
        }
    }
    return null;
}

function initializePopupPickers(): void {
    setTimeout(() => {
        initializePickers({
            picker: {
                type: EnumPickerType.SINGLE,
                selector: '[data-picker="plan-maps"]',
            },
            buttonSelector: '[data-picker-btn="plan-maps"]',
            itemSelector: '[data-picker-item="plan-maps"]',
            activeIndexes: [0],
            noSelected: false,
            activeClass: 'active',
        })
    }, 500)
}

function initializeSliders(): void {
    setTimeout(() => {
        const slider = new Swiper('[data-slider="gallery"]', {
            modules: [Navigation, EffectFade],
            speed: 400,
            effect: 'fade',
            slidesPerView: 1,
            slidesPerGroup: 1,
            navigation: {
                prevEl: '[data-controls="prev"]',
                nextEl: '[data-controls="next"]',
            },
            on: {
                init(swiper) {
                    const activeIndex = swiper.activeIndex

                    const activeSlide = swiper.slides[activeIndex] as HTMLElement

                    const name = activeSlide.dataset.name

                    if (!name) return

                    const titleEl = swiper.el.querySelector(
                        '[data-slide-title]',
                    ) as HTMLElement | null

                    if (titleEl) {
                        titleEl.textContent = name
                    }
                },
                slideChange(swiper) {
                    const activeIndex = swiper.activeIndex

                    const activeSlide = swiper.slides[activeIndex] as HTMLElement

                    const name = activeSlide.dataset.name

                    if (!name) return

                    const titleEl = swiper.el.querySelector(
                        '[data-slide-title]',
                    ) as HTMLElement | null

                    if (titleEl) {
                        titleEl.textContent = name
                    }
                },
            },
        })
    }, 500)
}

function fetchAndProcessContent(
    url: string,
    content: HTMLElement,
    popup: HTMLElement,
): void {
    fetch(url, {
        method: 'get',
    })
        .then((res) => res.text())
        .then((data) => {
            // Add new content
            content.insertAdjacentHTML('afterbegin', data)

            // Inject SVGs
            const svg = content.querySelectorAll('[data-item="svg"]')
            SVGInject.setOptions({
                afterInject: null,
            })
            SVGInject(svg)

            // Setup custom scrollbar
            setupCustomScrollbar(popup)

            window.dispatchEvent(new CustomEvent('bw-refresh-lightbox'))

            const selects = popup.querySelectorAll(`[data-form-select]`)
            if (selects.length > 0) {
                selects.forEach((select) => {
                    const choices = new Choices(select, {
                        allowHTML: true,
                        searchEnabled: false,
                    })
                })
            }

            const popoverTriggerList = document.querySelectorAll(
                '[data-bs-toggle="popover"]',
            )
            const popoverList = [...popoverTriggerList].map(
                (popoverTriggerEl) => new window.bootstrap.Popover(popoverTriggerEl),
            )

            popup.querySelectorAll('[data-tooltip-clause-more]').forEach((elem) => {
                // @ts-ignore
                tippy(elem, {
                    content(reference) {
                        const template = reference.getAttribute('data-content')
                        if (template) {
                            return template
                        }
                    },
                    theme: 'clause-more',
                    placement: 'top-start',
                    arrow: false,
                    interactive: true,
                    allowHTML: true,
                    // trigger: 'click',
                    appendTo: () => popup,
                    maxWidth: 'none',
                })
            })
        })
}

function setupCustomScrollbar(popup: HTMLElement): void {
    const scrollsContainers = popup.querySelectorAll<HTMLElement>(
        '[data-popup="scroll"]',
    )

    if (scrollsContainers.length === 0) return

    scrollsContainers.forEach((scrollsContainer) => {
        if (scrollsContainer.getAttribute('data-custom-scroll-active') !== 'true') {
            scrollsContainer.setAttribute('data-custom-scroll-active', 'true')
            new window.simplebar(scrollsContainer, {
                autoHide: false,
            })
        }
    })
}